

class UpsellPosterbox extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
        this.observeVariantChanges();
    }

    init() {
        this.querySelectorAll('.variant-select').forEach(select => {
            select.addEventListener('change', (e) => {
                this.updatePrice(e.target);
            });
        });
    }

    observeVariantChanges() {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        const productInfo = document.getElementById(`ProductInfo-${sectionId}`);
        if (!productInfo) return;

        const radios = productInfo.querySelectorAll('.product-form__input--color input[type="radio"]');

        const hideUpsell = this.dataset.hideUpsell || "";
        const blockedValues = hideUpsell
            .split(',')
            .map(v => v.trim().toLowerCase())
            .filter(v => v.length > 0);

        if (!radios.length) return;

        const upsellItems = this.querySelectorAll('.option-item[data-hide="true"]');

        const toggleUpsell = (value) => {
            const v = value.trim().toLowerCase();
            const isBlocked = blockedValues.includes(v);

            upsellItems.forEach(item => {
                item.style.display = isBlocked ? 'none' : '';

                const checkbox = item.querySelector('.option-checkbox');
                if (!checkbox) return;

                if (isBlocked) {
                    checkbox.checked = false;
                    checkbox.disabled = true;
                } else {
                    checkbox.disabled = false;
                }
            });
        };

        // Check on page load
        const checked = productInfo.querySelector('.product-form__input--color input[type="radio"]:checked');
        if (checked) toggleUpsell(checked.value);

        // Check on change
        radios.forEach(radio => {
            radio.addEventListener('change', (e) => {
                toggleUpsell(e.target.value);
            });
        });
    }





    updatePrice(selectElement) {
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        const price = selectedOption.dataset.price;
        const currencyFormat = window.theme.settings.money_with_currency_format || "${{amount}}";
        const optionItem = selectElement.closest('.option-item');
        const priceSpan = optionItem.querySelector('.option-price');
        
        if (price && priceSpan) {
            const formattedPrice = formatMoney(price, currencyFormat);
            priceSpan.textContent = `(${formattedPrice})`;
            priceSpan.dataset.productPrice = price;
        }
    }

    getSelectedProducts() {
        const selected = [];
        
        this.querySelectorAll('.option-checkbox:checked').forEach(checkbox => {
            const productId = checkbox.dataset.productId;
            const optionItem = checkbox.closest('.option-item');
            const variantSelect = optionItem.querySelector('.variant-select');
            let variantId;
            
            if (variantSelect) {
                variantId = variantSelect.value;
            } else {
                const hiddenInput = optionItem.querySelector('.selected-variant-id');
                variantId = hiddenInput ? hiddenInput.value : null;
            }
            
            if (variantId) {
                selected.push({
                    productId: productId,
                    variantId: variantId
                });
            }
        });
        
        return selected;
    }
}

if (!customElements.get('upsell-posterbox')) {
    customElements.define('upsell-posterbox', UpsellPosterbox);
}
